;(function (win) {
  let serialize = require('form-serialize');

  class DirectPayPayment {
    constructor(options = {}) {
      this.directPayUrl   = options['directPayUrl']
      this.buttonPlace    = options['button']       || 'directpay-button';
      this.formSelector   = options['form']         || 'payment-form';

      this.directPayButton = this.createButton();

      this.listenFormChange();
    }

    createButton() {
      let button = document.createElement('a');
      button.setAttribute('rel', 'nofollow');
      button.setAttribute('data-method', 'post');
      button.setAttribute('href', '');
      button.innerHTML = `${I18n.t('common.pay_with_mobile')} <img src="/images/credit-cards-mobile.png" alt="Mobile payment">`;
      return button;
    }

    paymentUrl() {
      let pForm = document.getElementById(this.formSelector)
      if (!pForm) {
        return this.directPayUrl;
      }

      let conntector = this.directPayUrl.includes('?') ? '&' : '?';
      return `${this.directPayUrl}${conntector}${serialize(pForm)}`;
    }

    listenFormChange() {
      let self = this;
      let pForm = document.getElementById(this.formSelector)
      if (!pForm) {
        return;
      }

      pForm.addEventListener('change', self.renderButton.bind(self));
    }

    renderButton() {
      let self = this;
      let buttonPlace = document.getElementById(self.buttonPlace);
      let url = self.paymentUrl();

      // faster than `buttonPlace.innerHTML = '';`
      while (buttonPlace.firstChild) {
        buttonPlace.removeChild(buttonPlace.firstChild);
      }

      self.directPayButton.setAttribute('href', url);
      buttonPlace.appendChild(self.directPayButton);
    }

  }

  win.DirectPayPayment = DirectPayPayment;

}(window))


// WEBPACK FOOTER //
// ./app/webpacker/src/js/payments/directpay.js